export default __webpack_public_path__ + "static/media/card-sip-icon.b61115b0.svg";